<template>
    <div class="curator-table justify-content-center">
        <table-view
            :options="options"
            :isLoaded=isLoaded
            :isChange="isChange"
            v-on:on-search="onSearchEnter">
            <div slot="curators" slot-scope="props">
                <router-link :to="{ name: 'curator-edit', params: { id: props.row.id }}" class="name-link">
                    <div class="icon-circle icon-indigo">
                        <span class="text-uppercase" v-if="!isMobile">{{props.row.displayName | toFirstLetter}}</span>
                    </div>
                    <strong>{{props.row.displayName}}</strong>
                </router-link>
            </div>
            <div slot="curator-edit" slot-scope="props" v-if="isMobile">
                <router-link :to="{ name: 'curator-edit', params: { id: props.row.id }}">
                    <strong>{{props.row.displayName}}<br>
                        {{props.row.lastName}}
                    </strong>
                </router-link>
            </div>
            <div slot="action" slot-scope="props"  v-if="!isMensurationForbidden">
                <client-btn v-if="canUpdateCurator || canDeleteCurator"
                            :item="props.row"
                            :showEdit="canUpdateCurator"
                            :showDelete="canDeleteCurator"
                            v-on:editItem="onEditBtnClick"
                            v-on:deleteItem="onDeleteBtnClick">
                </client-btn>
            </div>

            <div slot="therapistsCount" slot-scope="props">
                {{props.row.therapistsCount}}/{{props.row.clientsCount}}
            </div>

            <div slot="bidsOnWorkCount" slot-scope="props">
                {{props.row.bidsOnWorkCount}}/{{props.row.overdueBidsCount}}
            </div>

        </table-view>

        <div class="row pager-btn-row">
            <div v-if="canCreateCurator && !isMensurationForbidden" class="col-md-12 text-right">
                <mdc-button class="button-primary" raised @click="onAddCuratorModalBtnClick">
                    {{ 'user.add_curator' | trans }}
                </mdc-button>
            </div>
        </div>


        <curator-modal :visible="isModalVisible"
                       :data="modal.data"
                       v-on:close="onModalClose">
        </curator-modal>

    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import lang from '../../../../lang/translator';
  import Paginate from 'vuejs-paginate';
  import curatorModal from './Modal';
  import clientBtn from '../../client/components/ClientBtn';
  import Loader from '../../../loader/components/Loader';
  import isEmpty from 'lodash/isEmpty';
  import Search from '../../../../common/table/Search';
  import TableView from '../../../../common/table/components/TableView';

  export default {
    name: 'Curators',
    data() {
      return {
        isModalVisible: false,
        paginate: {
          perPage: 10,
          page: 0,
          forcePage: 0,
          pageRange: 3,
          marginPages: 2,
        },
        isChange: false,
        modal: {
          data: {},
        },
        options: {
          pageHeader: 'curators',
          filterable: false,
          initialPage: null,
          sortable: [],
          withSearch: true,
          placeholder: '',
          debounce: 1500,
          skin: 'table table-sm',
          columns: [
            {
              key: 'curators',
              changed: true,
              headings: lang.get('user.curators')
            },
            {
              key: 'therapistsCount',
              changed: true,
              headings: lang.get('user.therapists') + '/ ' + lang.get('user.clients')
            },
            {
              key: 'bidsOnWorkCount',
              changed: true,
              headings: lang.get('user.request_for_work_overdue')
            },
            {
              key: 'action',
              changed: true,
              headings: ''
            }
          ],
          requestFunction: this.requestFunction,
          responseAdapter: function(resp) {
            return {
              data: resp.items,
              count: resp.total
            }
          },
          texts:{
            filter:"",
            filterPlaceholder: lang.get('user.type_the_curator_name_to_search'),
            noResults:lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table')
          },
          columnsClasses:{
            curators: 'mw120',
            therapistsCount: 'text-center',
            bidsOnWorkCount: 'text-center',
            action:'table-actions'
          },
          perPage: 10
        },
        search: '',
        sort: '-id',
      };
    },
    components: {
      Search, Paginate, curatorModal, clientBtn, Loader, TableView
    },

    computed: {
      ...mapGetters('curator/repository', [
        'items',
        'page',
        'pageCount',
        'total',
        'hasMorePages',
        'isLoaded',
        'isChanged'
      ]),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      ...mapGetters('auth', [
        'canCreateCurator',
        'canUpdateCurator',
        'canDeleteCurator',
        'isMensurationForbidden',
      ]),
      isEmptyList: function() {
        return isEmpty(this.items);
      },
    },
    methods: {
      ...mapActions('curator/repository', [
        'getItems',
        'deleteItemById',
      ]),
      getTranslation(...args) {
        return lang.get(...args);
      },
      async getCurators(page, sort, search) {
        localStorage.setItem('currentPage', page);
        localStorage.setItem('currentPageHeader', 'curators');
        let response = await this.getItems({
          perPage: this.options.perPage,
          page,
          sort: sort ? sort : this.sort,
          search: search ? search : this.search,
        });

        return response;
      },
      async requestFunction (data) {
        return this.getCurators(data.page,this.sort,data.query)
      },

      onAddCuratorModalBtnClick() {
        this.modal.data = {};
        this.isModalVisible = true;
        this.isChange = false;
      },
      onModalClose() {
        this.modal.data = {};
        this.isModalVisible = false;
        this.isChange = true;
      },
      onEditBtnClick(item) {
        this.modal.data = {item};
        this.isModalVisible = true;
        this.isChange = false;
      },
      onDeleteBtnClick: async function(id) {
        this.isChange = false;
        await this.deleteItemById({id});
        let response = await this.getCurators(this.page);

        if (response){
          this.isChange = true;
        }

        this.setPaginateState(this.page);
      },
      async onPaginationClick(page) {
        await this.getCurators(page);
        this.setPaginateState(page);
      },
      setPaginateState(page) {
        this.paginate.page = page;
        this.paginate.forcePage = page - 1;
      },
      onSearchEnter: function(search) {
        this.search = search;
      },
    },
    watch: {
      pageCount(newValue, oldValue) {
        // spike :
        if (newValue > 1 && oldValue === 1) {
          this.paginate.page = 0;
          this.paginate.forcePage = 0;
        }
      },
      page(newValue, oldValue) {
        // spike :
        if (newValue === 1 && oldValue > 1) {
          this.paginate.page = 0;
          this.paginate.forcePage = 0;
        }
      },
      isChanged(newValue, oldValue) {
        if (newValue) {
          this.isChange = newValue
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/user/curator/components/List.vue